import { Box, Divider, SpeedDial, SpeedDialIcon, Typography } from '@mui/material'
import React, { useState } from 'react';
import {TableCategories} from '../TableCategories/TableCategories';
import Category from '../category/Category';


const PageCategories = () => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({ id: 0, name: '' });
  const [editing, setEditing] = useState(false);
  const [changed, setChanged] = useState(false);

  const handleNewCategory = () => {
    setValues({ id: 0, name: '' });
    setOpen(true);
    setEditing(false);
  }

  const handleChanged = () => {
    setChanged(!changed);
  }


  return (
    <div style={{padding: 5, }}>
      <Box sx={{m: 2}}>
       <Category open={open} setOpen={setOpen} values={values} setValues={setValues} editing={editing} setChanged={setChanged} changed={changed}/>
       <TableCategories open={open} setOpen={setOpen} values={values} setValues={setValues} setEditing={setEditing} handleChanged={handleChanged} changed={changed}/>
      </Box>
      <SpeedDial
            ariaLabel="Nova Categoria"
            sx={{ position: 'fixed', bottom: 60, right: 80, }}
            icon={<SpeedDialIcon  />}
            onClick={() => handleNewCategory()}
            >
      </SpeedDial>   
    </div>
  )
}

export default PageCategories